var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaDienstplan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#59667c;}.cls-3{fill:#fff;}.cls-4{fill:#9093aa;}.cls-5{fill:#76b72a;}.cls-6{fill:#009bd9;}.cls-7{fill:#bcbecc;}.cls-8{fill:#eb5c0b;}.cls-9{fill:#76b82a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8,
    y: 27.19,
    width: 144,
    height: 32.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "8 59.77 8 141.94 129.8 141.94 129.8 119.73 152 119.73 152 59.77 8 59.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.8 141.94 152 119.73 129.8 119.73 129.8 141.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 43.48,
    y: 67.45,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 70.25,
    y: 67.45,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 97.22,
    y: 67.45,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 123.99,
    y: 67.45,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 16.71,
    y: 91.52,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 43.48,
    y: 91.52,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 70.25,
    y: 91.52,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 97.22,
    y: 91.52,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 123.99,
    y: 91.52,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 16.71,
    y: 115.59,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 43.48,
    y: 115.59,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 70.25,
    y: 115.59,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 97.22,
    y: 115.59,
    width: 16.81,
    height: 16.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 122.33,
    y: 18.06,
    width: 8.3,
    height: 16.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 91.41,
    y: 18.06,
    width: 8.3,
    height: 16.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 60.29,
    y: 18.06,
    width: 8.3,
    height: 16.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 29.37,
    y: 18.06,
    width: 8.3,
    height: 16.39
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaDienstplan);
export default __webpack_public_path__ + "static/media/ka_dienstplan.b865cc34f825fb276af9ac5fa11f5527.svg";
export { ForwardRef as ReactComponent };